import React from 'react';
import SEOHead from '@/components/SEOHead';
import { ThemeProvider } from '@/components/ThemeProvider';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

/**
 * Terms and Conditions page component
 * Provides comprehensive terms and conditions for the website
 * Includes usage terms, liability limitations, and user responsibilities
 */
const TermsAndConditions = () => {
  return (
    <>
      <SEOHead 
        title="Terms and Conditions - Matthew Innes Portfolio"
        description="Terms and conditions for Matthew Innes portfolio website. Read our terms of service and usage guidelines."
        canonical="https://matthewweb.com/terms-and-conditions"
      />
      <ThemeProvider>
        <div className="min-h-screen flex flex-col bg-background text-foreground dark:bg-navy dark:text-lightSlate">
          <Navbar />
          <main className="flex-grow container mx-auto px-4 py-16 max-w-4xl">
            <div className="prose prose-lg max-w-none dark:prose-invert">
              <h1 className="text-4xl font-bold mb-8">Terms and Conditions</h1>
              <p className="text-lg text-muted-foreground mb-8">
                Last updated: {new Date().toLocaleDateString('en-GB')}
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
                <p className="mb-4">
                  By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">2. Use License</h2>
                <p className="mb-4">
                  Permission is granted to temporarily download one copy of the materials on Matthew Innes's website for personal,
                  non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                </p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Modify or copy the materials</li>
                  <li>Use the materials for any commercial purpose or for any public display</li>
                  <li>Attempt to reverse engineer any software contained on the website</li>
                  <li>Remove any copyright or other proprietary notations from the materials</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">3. Disclaimer</h2>
                <p className="mb-4">
                  The materials on Matthew Innes's website are provided on an 'as is' basis. Matthew Innes makes no warranties,
                  expressed or implied, and hereby disclaims and negates all other warranties including without limitation,
                  implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">4. Limitations</h2>
                <p className="mb-4">
                  In no event shall Matthew Innes or its suppliers be liable for any damages (including, without limitation,
                  damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use
                  the materials on Matthew Innes's website, even if Matthew Innes or an authorised representative has been notified
                  orally or in writing of the possibility of such damage.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">5. Accuracy of Materials</h2>
                <p className="mb-4">
                  The materials appearing on Matthew Innes's website could include technical, typographical, or photographic errors.
                  Matthew Innes does not warrant that any of the materials on its website are accurate, complete, or current.
                  Matthew Innes may make changes to the materials contained on its website at any time without notice.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">6. Links</h2>
                <p className="mb-4">
                  Matthew Innes has not reviewed all of the sites linked to the website and is not responsible for the contents
                  of any such linked site. The inclusion of any link does not imply endorsement by Matthew Innes of the site.
                  Use of any such linked website is at the user's own risk.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">7. Modifications</h2>
                <p className="mb-4">
                  Matthew Innes may revise these terms of service for its website at any time without notice.
                  By using this website, you are agreeing to be bound by the then current version of these terms of service.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">8. Contact Information</h2>
                <p className="mb-4">
                  If you have any questions about these terms and conditions, please contact us through our contact form.
                </p>
              </section>
            </div>
          </main>
          <Footer />
        </div>
      </ThemeProvider>
    </>
  );
};

export default TermsAndConditions;
